/**
 * Replaces current Data about sale
 * @param {*} state
 * @param {*} typePayLoad
 */
const SET_EMPLOYEE = function(state, employee) {
    state.employee = employee
}

export default {
    SET_EMPLOYEE,
}
